/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useContext } from "react";
import img_src from "../../assets/images/placeholder.svg";
import LoginForm from "./LoginForm/LoginForm";
import { AuthContext } from "../../context/AuthContext";
import { Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
const LoginPage = () => {
  // Sử dụng useEffect để cuộn trang lên đầu sau khi component được render
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Tạo hiệu ứng cuộn nhẹ
    });
  }, []); // Mảng rỗng đảm bảo rằng hiệu ứng chỉ chạy một lần sau khi component mount
  const { isLogin } = useContext(AuthContext);
  //Check trạng thái login của nó xem login chưa,
  //  nếu login rồi sẽ ngăn không cho vào lại trang login ╰(*°▽°*)╯
  if (isLogin === true) {
    return <Navigate to="/" />;
  }
  return (
    <>
      <Helmet>
        <title>Đăng nhập • VMO</title>
        <meta
          name="description"
          content="Mô hình tình nguyện cho người có hoàn cảnh khó khăn"
        />
      </Helmet>
      <div className="w-full tablet:grid tablet:min-h-[600px] tablet:grid-cols-2 laptop:min-h-[800px]">
        {/* LEFT */}
        <div className="hidden  tablet:block overflow-hidden min-h-screen">
          <img
            src={require('../../assets/images/banner_v2.png')}
            alt="Image"
            className="w-full object-cover object-center h-full"
          />
        </div>
        {/* RIGHT */}
        <div className="flex items-center justify-center py-12 tablet:h-2/3 min-h-screen">
          <LoginForm />
        </div>
      </div>
    </>
  );
};

export default LoginPage;
